import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { clearCsrfToken } from '../api/csrf';
import { subscribeSessionExpired } from '../auth/sessionExpiry';
import { queryKeys } from '../lib/queryKeys';
import { ROUTES } from '../lib/routes';
import { ToastViewport, pushToast } from '../components/ui';

/**
 * Subscribes once to the global session-expiry signal (spec §12.3). The signal
 * is already deduplicated, so this clears cached user data, shows a single
 * toast, and redirects to /login exactly once per burst of 401s.
 */
function GlobalSessionWatcher() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(
    () =>
      subscribeSessionExpired(() => {
        clearCsrfToken();
        queryClient.removeQueries({ queryKey: queryKeys.session });
        queryClient.removeQueries({ queryKey: queryKeys.me });
        queryClient.removeQueries({ queryKey: queryKeys.identities });
        pushToast('Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.', 'error');
        navigate(ROUTES.login, { replace: true });
      }),
    [navigate, queryClient],
  );

  return null;
}

/** Root layout element: hosts global watchers and the toast viewport. */
export function App() {
  return (
    <>
      <GlobalSessionWatcher />
      <Outlet />
      <ToastViewport />
    </>
  );
}
